export default "__VITE_ASSET__D1e7wFWs__"